const NotificationTypeEnum = {
    Success: "Success",
    Failure: "Failure"
};

export default NotificationTypeEnum;